import React, { useEffect, useState } from 'react';
import { actions } from 'redux/actions';
import Shared from 'screens/shared';
import { useSelector } from 'react-redux';
import { capitalize } from 'utils';

export default ({ clusterId = '', nodepoolId = '', nodepoolState = '' }) => {
  const [nodesList, setNodesList] = useState([]);
  const [deleteId, setDeleteId] = useState('');
  const [recreateId, setRecreateId] = useState('');

  const { nodes = [], listViewType = '' } = useSelector((e) => e);

  useEffect(() => {
    setNodesList([...nodes]);
  }, [nodes]);

  const onDelete = (confirm) => {
    if (confirm) {
      actions.kubernetes.node.delete({
        clusterId, nodepoolId, id: deleteId,
      });
    }
    setDeleteId('');
  };

  const onRecreate = (confirm) => {
    if (confirm) {
      actions.kubernetes.node.recreate({
        clusterId, nodepoolId, id: recreateId,
      });
    }
    setRecreateId('');
  };

  return (
    <div style={{ margin: '15px 10px' }} className="screen-common">
      <Shared.widgets.Cards
        title="Nodes"
        type="common"
        isFilter={false}
        isAdd={false}
        isEmpty={!nodesList.length}
      >
        {listViewType === 'table' ? (
          <Shared.widgets.TableView
            name="servers"
            rows={
              nodesList.map((node) => {
                const { properties = {}, id = '', metadata = {} } = node;
                const { name = '', publicIP = '', k8sVersion = '' } = properties;
                const { state = '' } = metadata;

                return ([
                  <Shared.utilities.StatusLED state={state} />,
                  name,
                  k8sVersion,
                  publicIP,
                  <span>
                    <Shared.widgets.Icon name="trash" onClick={() => setDeleteId(id)} style={{ color: 'var(--color-danger)' }} />
                    <Shared.widgets.Icon name="undo" onClick={() => setRecreateId(id)} style={{ color: 'var(--color-base)' }} />
                  </span>,
                ]);
              })
            }
            columns={[
              { name: '' },
              { name: 'Name' },
              { name: 'Version' },
              { name: 'IP' },
              { name: '' },
            ]}
          />
        ) : (nodesList.map((node) => {
          const { properties = {}, id = '', metadata = {} } = node;
          const { name = '', publicIP = '', k8sVersion = '' } = properties;
          const { state = '' } = metadata;

          return (
            <Shared.widgets.CardBasic
              title={name}
              icon="server"
              iconText="Node"
              details={(
                <>
                  <Shared.utilities.StatusLED state={state} />
                  <span style={{ marginLeft: 5 }}>{capitalize(state)}</span>
                  <Shared.utilities.Separator />
                  <span>{k8sVersion}</span>
                  <Shared.utilities.Separator />
                  <span>{publicIP}</span>
                </>
              )}
              isLoader={state !== 'READY' || nodepoolState !== 'ACTIVE'}
              buttons={[
                {
                  className: 'danger-txt',
                  name: 'trash',
                  onClick: () => setDeleteId(id),
                },
                {
                  className: 'primary-txt',
                  name: 'undo',
                  title: 'Rebuild',
                  onClick: () => setRecreateId(id),
                },
              ]}
              key={id}
            />
          );
        }))}
      </Shared.widgets.Cards>
      <Shared.dialog.Confirm show={!!deleteId} onClose={onDelete} />
      <Shared.dialog.Confirm show={!!recreateId} onClose={onRecreate} />
    </div>
  );
};
